import React, {useState} from "react";
import {CustomBadge} from "@pages/new-design-components/custom-components";

const {CustomDropdown, DropdownButton, Dot, ArrowIcon} = require("@pages/new-design-components/custom-components");
const {DropdownMenu, DropdownItem} = require("reactstrap");
const {fleetNewStatuses} = require("../../../../constants");

export default function CustomDropdownComponent({selectedTitle,
                                                    handleChange,
                                                    statusArrayKey = 'interiorStatuses',
                                                    border = null,
                                                    maxWidth = null,
                                                    withoutDot = false,
                                                    noBadge = false,
                                                    buttonHeight = null,
                                                    disabled = false,
                                                    selectedPlaceHolder = '-',
})  {

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

    const selected = fleetNewStatuses[statusArrayKey].find(status => status.key === selectedTitle) || {};

    return ( <CustomDropdown minWidth={'250px'}  isOpen={dropdownOpen} toggle={toggleDropdown} >
        <DropdownButton maxWidth={maxWidth} border={border} buttonHeight={buttonHeight} disabled={disabled}>
            {
                withoutDot ? (
                        noBadge ? <span>{selected.title || selectedPlaceHolder}</span> : <CustomBadge type={selected.key}   active>
                            {selected.title || selectedPlaceHolder}
                        </CustomBadge>
                    )
                    :
                    <div className={'d-flex align-items-center g-5'}>
                        <Dot color={selected.color} /> {selected.title || selectedPlaceHolder}
                    </div>
            }

            <ArrowIcon
                isOpen={dropdownOpen}
                src={require("assets/images/arrow_forward_ios.png")}
                alt="Dropdown Arrow"
            />
        </DropdownButton>
        <DropdownMenu className={'w-100'}>
            {fleetNewStatuses[statusArrayKey].map((title) => (
                <DropdownItem key={title.key} disabled={!!title.disabled} onClick={() => {
                    handleChange(title.key)
                    setDropdownOpen(false);
                }}>
                    <Dot color={title.color} />
                    {title.title}
                </DropdownItem>
            ))}
        </DropdownMenu>
    </CustomDropdown>
  )
}
